import Icon from '../../components/Icon.vue'

Icon.register({"regular/hourglass":{"width":384,"height":512,"paths":[{"d":"M368 48H372C378.6 48 384 42.6 384 36V12C384 5.4 378.6 0 372 0H12C5.4 0 0 5.4 0 12V36C0 42.6 5.4 48 12 48H16C16 128.6 48.2 213.8 113.2 256 47.9 298.4 16 383.9 16 464H12C5.4 464 0 469.4 0 476V500C0 506.6 5.4 512 12 512H372C378.6 512 384 506.6 384 500V476C384 469.4 378.6 464 372 464H368C368 383.4 335.8 298.2 270.8 256 336.1 213.6 368 128.1 368 48zM64 48H320C320 149.6 262.7 232 192 232S64 149.6 64 48zM320 464H64C64 362.4 121.3 280 192 280S320 362.4 320 464z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/regular/hourglass.js